import { FormInput } from "@Rolec-Services/rolec-ui";
import { useTranslation } from "react-i18next";
import { StepProps } from "~/components/organisms/step";

export function Team({ control }: { control: StepProps["control"] }) {
  const { t } = useTranslation();
  return (
    <>
      <FormInput
        errorMessage={t("Required")}
        control={control}
        name="team.name"
        label={t("Team Name")}
      />
    </>
  );
}
